import React from 'react';

import {MOBILE_MAX_SCREEN_SIZE} from 'base/search.js';
import SkeletonCardV2 from 'directory/v2/components/SkeletonCardV2.js';

function getSkeletonCount() {
    if (window.matchMedia(`(max-width: ${MOBILE_MAX_SCREEN_SIZE})`).matches) {
        return 3;
    }
    return 5;
}

export default function SkeletonCardListV2() {
    const count = getSkeletonCount();
    return (
        <section aria-busy="true" data-testid="skeleton-loading">
            <ul>
                {Array.from({length: count}, (_, i) => (
                    <SkeletonCardV2 key={i} />
                ))}
            </ul>
        </section>
    );
}
